/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionEventDTO } from './SessionEventDTO';
import {
    SessionEventDTOFromJSON,
    SessionEventDTOFromJSONTyped,
    SessionEventDTOToJSON,
} from './SessionEventDTO';

/**
 * 
 * @export
 * @interface TimedSessionEventDTO
 */
export interface TimedSessionEventDTO {
    /**
     * 
     * @type {SessionEventDTO}
     * @memberof TimedSessionEventDTO
     */
    event: SessionEventDTO;
    /**
     * Timestamp of the event, set in the backend
     * @type {number}
     * @memberof TimedSessionEventDTO
     */
    timestampMillis: number;
}

/**
 * Check if a given object implements the TimedSessionEventDTO interface.
 */
export function instanceOfTimedSessionEventDTO(value: object): value is TimedSessionEventDTO {
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('timestampMillis' in value) || value['timestampMillis'] === undefined) return false;
    return true;
}

export function TimedSessionEventDTOFromJSON(json: any): TimedSessionEventDTO {
    return TimedSessionEventDTOFromJSONTyped(json, false);
}

export function TimedSessionEventDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimedSessionEventDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'event': SessionEventDTOFromJSON(json['event']),
        'timestampMillis': json['timestampMillis'],
    };
}

export function TimedSessionEventDTOToJSON(value?: TimedSessionEventDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'event': SessionEventDTOToJSON(value['event']),
        'timestampMillis': value['timestampMillis'],
    };
}

